<div class="login-register"
 >
  <div class="login-register-box">

    <mat-card class="m-t-10">
      <mat-card-content>
        <mat-card-title>ACCEDI ALL'AREA PRIVATA</mat-card-title>
        <mat-card-subtitle>L'accesso è consentito solo agli utenti verificati</mat-card-subtitle>

        <form id="loginform">
      
          <div *ngIf="msg" class="bg-danger p-10 text-white">{{ msg }}</div>
          <div fxLayout="row wrap">
            <!-- col full-->
            <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
              <mat-form-field>
                <input matInput placeholder="Username" required="" #u1 (keypress)="eventHandler($event, u1.value, p2.value)">
              </mat-form-field>
            </div>
            <!-- col full-->
            <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
              <mat-form-field>
                <input matInput type="password" placeholder="Password" required="" #p2 (keypress)="eventHandler($event, u1.value, p2.value)">
              </mat-form-field>
            </div>


            <!-- col full-->
            <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
              <button mat-raised-button color="primary" class="btn-block btn-lg m-t-20 m-b-20"
                      (click)="check(u1.value, p2.value)" type="button">
                Login
              </button>
            
              <button mat-raised-button color="primary" class="btn-block btn-lg m-t-20 m-b-20" style="float: right !important"
                      (click)="btnRecuperaPassword()" type="button">
                Recupera Password
              </button>
            </div>
            <br />
            <!--col full-->
            <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" class="text-center">
              <span>
                dev by <a href="https://www.codher.it" class="link" target="_blank"> codher </a>

              </span>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
